import type { RefObject } from 'react';

import { createSafeContext } from '@/util';

const FileBrowserContentDragboxContext = createSafeContext<{
  $dragboxParent: RefObject<HTMLElement>;
}>();

export default FileBrowserContentDragboxContext;
